"use client";
import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

function useTopLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    setIsLoading(true);
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return { isLoading };
}

export default useTopLoader;
